import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PickupAssignmentComponent } from './pickup-assignment/pickup-assignment.component';
import { RouteDetailsComponent } from './route-summary/route-details/route-details.component';
import { RouteSummaryComponent } from './route-summary/route-summary.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'route-summary',
    component: RouteSummaryComponent,
  },
  {
    path: 'pickup-assignment',
    component: PickupAssignmentComponent,
  },
  {
    path: 'route-summary/route-details/:id',
    component: RouteDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OperationsRoutingModule {}
